import React from 'react';
import { Tag } from './Tag';
export var Tags = function (_a) {
    var tags = _a.tags;
    if (!(tags === null || tags === void 0 ? void 0 : tags.length)) {
        return null;
    }
    return (React.createElement("ul", { className: "flex flex-wrap leading-normal" }, tags.all().map(function (tag) { return (React.createElement("li", { className: "inline-block mt-2 mr-2", key: tag.name() },
        React.createElement(Tag, { tag: tag }))); })));
};
//# sourceMappingURL=Tags.js.map